import React, { Component } from 'react'
import Footer from '../components/Footer'
import Mainmenu from '../components/Mainmenu'
import Navbar from '../components/Navbar'

import VideoGalleryListContent from './VideoGalleryListContent'
export default class VideoGalleryList extends Component {

    render() {

        const urlParams = new URLSearchParams(window.location.search);
        let page =
            this.props.match.params.page ?? urlParams.get("page") ?? undefined;

        return (
            <div className="wrapper">
                <Navbar />
                <Mainmenu />
                <VideoGalleryListContent urlParams={urlParams} page={page} />
                <Footer />

            </div>


        )
    }
}
